// Axios
import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// jQuery
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// Bootstrap
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Optional: Import Popper explicitly
import '@popperjs/core';

// Datatables and components
import DataTables from 'datatables.net-bs5';
import 'datatables.net-select-bs5';
window.DataTables = DataTables;

// jQuery Validation plugin
import 'jquery-validation'

// Moment Library - dependency of daterangepicker
// import moment from '/node_modules/daterangepicker/moment.min.js';
// window.moment = moment;


// import daterangepicker from '/node_modules/daterangepicker/daterangepicker.js';
// window.daterangepicker = daterangepicker;

import AirDatepicker from 'air-datepicker'
import localeEn from 'air-datepicker/locale/en';
window.datepicker = AirDatepicker;
window.datepickerLocalEn = localeEn;

// Select2 Library
(async function loadSelect2() {
    try {
        const select2 = await import('/node_modules/select2/select2.js');
		window.select2 = $.fn.select2;
        // console.log('Select2 dynamically loaded:', typeof $.fn.select2);

    } catch (error) {
        console.error('Error loading Select2:', error);
    }
})();

// Toastr
import toastr from 'toastr'
window.toastr = toastr;




// Export an object summarizing what is set up
export default {
    axios: window.axios,
    jQuery: window.$,
	bootstrap: bootstrap,
	$: window.$,
    // moment: window.moment,
	DataTables: window.DataTables,
    // daterangepicker: window.daterangepicker,
	datepicker: window.datepicker,
	datepickerLocalEn: window.datepickerLocalEn,
    select2: window.select2,
	toastr: window.toastr,
};


